module.exports = __webpack_public_path__ + "static/NeueMontreal-Regular-656ec3be5d2234eb0ee9fa8b497a20c8.woff";